import { ActionKeys } from "../pb-screen/action.keys";
import { DepotGuardEntry, DepotOptimisticGuard } from "./depot-optimistic-guard.models";
import { IAppState } from "./IAppState";
import * as InitialState from "./initial.state";

/* NOTE: When adding a case be sure you add it to the fallthrough in the reducer.ts file */
export function depotOptimisticGuardReducer(state: IAppState = InitialState.initialState, action): IAppState {
  switch (action.type) {
    case ActionKeys.REGISTER_DEPOT_GUARD:
      return registerDepotGuard(state, action);
    case ActionKeys.RESOLVE_DEPOT_GUARD:
      return resolveDepotGuard(state, action);
    case ActionKeys.FLAG_DEPOT_GUARD:
      return flagDepotGuard(state, action);
    case ActionKeys.SET_DEPOT_GUARD_RESULT:
      return setDepotGuardResult(state, action);
    default:
      return state;
  }
}

function registerDepotGuard(state: IAppState, action): IAppState {
  const guard: DepotOptimisticGuard = { ...(state.depotOptimisticGuard || {}) };
  (action.entries as DepotGuardEntry[]).forEach(entry => {
    guard[entry.pbId] = entry;
  });
  return Object.assign({}, state, { depotOptimisticGuard: guard });
}

function resolveDepotGuard(state: IAppState, action): IAppState {
  const guard: DepotOptimisticGuard = { ...(state.depotOptimisticGuard || {}) };
  (action.pbIds as string[]).forEach(pbId => { delete guard[pbId]; });
  return Object.assign({}, state, { depotOptimisticGuard: guard });
}

function setDepotGuardResult(state: IAppState, action): IAppState {
  const current = state.depotOptimisticGuard || {};
  const guard: DepotOptimisticGuard = { ...current };
  let changed = false;
  (action.pbIds as string[]).forEach(pbId => {
    if (guard[pbId]) {
      guard[pbId] = { ...guard[pbId], toId: action.toId };
      changed = true;
    }
  });
  return changed ? Object.assign({}, state, { depotOptimisticGuard: guard }) : state;
}

function flagDepotGuard(state: IAppState, action): IAppState {
  const current = state.depotOptimisticGuard || {};
  const existing = current[action.pbId];
  if (!existing) return state;
  const guard: DepotOptimisticGuard = { ...current };
  guard[action.pbId] = {
    ...existing,
    state: "flagged",
    reason: action.reason || existing.reason,
    refetchedAt: action.refetched ? new Date().toISOString() : existing.refetchedAt,
  };
  return Object.assign({}, state, { depotOptimisticGuard: guard });
}
